import { render, staticRenderFns } from "./PatientList.vue?vue&type=template&id=fa09aaea&scoped=true"
import script from "./PatientList.vue?vue&type=script&lang=js"
export * from "./PatientList.vue?vue&type=script&lang=js"
import style0 from "./PatientList.vue?vue&type=style&index=0&id=fa09aaea&prod&lang=scss&scoped=true"
import style1 from "./PatientList.vue?vue&type=style&index=1&id=fa09aaea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa09aaea",
  null
  
)

export default component.exports